import { render } from "./InsuranceRuleEngine.vue?vue&type=template&id=c374488c&scoped=true"
import script from "./InsuranceRuleEngine.vue?vue&type=script&lang=js"
export * from "./InsuranceRuleEngine.vue?vue&type=script&lang=js"

import "./InsuranceRuleEngine.vue?vue&type=style&index=0&id=c374488c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c374488c"]])

export default __exports__